// extracted by mini-css-extract-plugin
module.exports = {"prompt":"Prompt_prompt__tMTJt","promptButtons":"Prompt_promptButtons__U7yRB"};